import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { TagsInput } from 'shared/components/TagsInput';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectContainWordsFilter } from 'shared/selectors/advancedFilters';

export const ContainWordsContainer: FC = () => {
  const { label, value: values, placeholder } = useSelector(selectContainWordsFilter);

  const onChange = useFilterChangeCallback();

  const handleAdd = useCallback(
    (addedValue: string) => {
      onChange({ action: 'setContainWords', arguments: [values ? [...values, addedValue] : [addedValue]] });
    },
    [onChange, values],
  );

  const handleRemove = useCallback(
    (removedValue: string) => {
      const nextValues = values ? values.filter(value => value !== removedValue) : null;

      onChange({ action: 'setContainWords', arguments: [nextValues?.length ? nextValues : null] });
    },
    [onChange, values],
  );

  return (
    <AdvancedFilterRow label={label}>
      <TagsInput
        id="advancedFilter_containWords_tagsInput"
        placeholder={placeholder}
        value={values}
        onAdd={handleAdd}
        onRemove={handleRemove}
      />
    </AdvancedFilterRow>
  );
};
